import axios from 'axios';
import store from '../store';
import CryptoJS from 'crypto-js';
import router from '../router';

const baseURL = 'https://toynama.uqrixayli.com/top/';
// const baseURL = 'http://192.168.2.12:8080/';


const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  proxy: false,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
});


instance.interceptors.request.use(
  (config) => {
    const token = store.state.token;

    if (token) {

      const secret = 'Toyname256'; 
      const timestamp = new Date().getTime();
      const message = `${token}|${timestamp}`;
      const signature = CryptoJS.HmacSHA256(message, secret).toString();
      config.headers.ShopToken = `${token}|${timestamp}|${signature}`;

    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const requestUrl = response.config.url;
    // console.log('请求接口:', requestUrl);

    if (requestUrl != 'adminShop/shop' && response.data.code == 401) {
      store.commit('logout');
      router.replace({ name: 'Login' });
      return null;
    }


    return response.data;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 封装 GET 请求
export const get = (url, params = {}) => {
  return instance
    .get(url, { params })
    .then((response) => response)
    .catch((error) => Promise.reject(error));
};

// 封装 POST 请求
export const post = (url, data = {}) => {
  return instance
    .post(url, data)
    .then((response) => response)
    .catch((error) => Promise.reject(error));
};


export const upload = (url, file, params = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  Object.keys(params).forEach(key => {
    formData.append(key, params[key]);
  });

  return instance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // 需要指定为 multipart/form-data
    }
  })
    .then(response => response)
    .catch(error => Promise.reject(error));
};

export default instance; 
